// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__6y64V"};